<template>
  <resize-table
    :scroll="{ x:400, y: height - 54 }"
    tableName="formulaNutritionColumns"
    :columns="formulaNutritionColumns"
    :loading="nutritonListLoading"
    :data-source="list.records"
    :row-key="record => record.nutritionId"
    :pagination="false"
    bordered
  >
      <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 指标名称</span>
    <template slot="nutritionValue" slot-scope="text,record">
      {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
    </template>
    >
    <template slot="productContent" slot-scope="text,record">
      {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
    </template>
    <template
      v-for="twin in ['maxApply', 'maxApply','productRawUasge','cost', 'minLimitValue','maxLimitValue']"
      :slot="twin"
      slot-scope="text,record"
    >
      <span v-if="twin === 'minLimitValue' || twin === 'maxLimitValue'" :key="twin">{{ text ? Number(text).toFixed(len(record)) : ''}}</span>
      <span v-else :key="twin">
        <span :key="twin" v-if="twin === 'cost'">{{ text ? Number(text).toFixed(3) : ''}}</span>
        <span :key="twin" v-else>{{ text || text === 0? Number(text).toFixed(3) : ''}}</span>
      </span>
    </template>
    <template v-for="col in ['minValue', 'maxValue']" :slot="col" slot-scope="text, record" >
      <cell-editor
        :key="col"
        :len="len(record)" :item="record" :name="col"
        @blur="target => itemUpdate(target)"
        :text="text"
        :actions="update"
      />
    </template>
  </resize-table>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue'
import { formulaMixins } from '../unitls'
export default {
  mixins:[formulaMixins],
  components: { CellEditor },
  data(){
    return {
      list:{
        records:[]
      },
      nutritonListLoading:false,
      filterType:null,
      filled: true,
      cacheData: []
    }
  },
  watch:{
    formula(item){
      if(item.id) this.getList({taskFormulaId:item.id})
    },
    resNut(val){
      if(val) this.getList()
    }
  },
  mounted(){
    this.getList()

  },
  methods:{
    getFilterList(){
      let nutritionCurrentType = window.localStorage.getItem('nutritionCurrentType')
      if(nutritionCurrentType) {
        this.filterNutrition(Number(nutritionCurrentType))
      }
    },
    changeColumns(){
      let formulaNutritionColumns = [...this.formulaNutritionColumns]
      if(this.filled){
        formulaNutritionColumns[0].fixed = 'left'
      }else{
        delete formulaNutritionColumns[0].fixed
      }
      this.setState({formulaNutritionColumns})
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns()
      e = e || window.event;
      if(e.stopPropagation) { //W3C阻止冒泡方法
          e.stopPropagation();
      } else {
          e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    itemUpdate(item){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const targets = newData.filter(i => i.nutritionId === item.nutritionId)[0]
      const targetCache = newCacheData.filter(i => i.nutritionId === item.nutritionId)[0]
      if (targets) {
        Object.assign(targetCache, item)
        Object.assign(targets, item)
        this.cacheData = newCacheData
        this.list.records = newData
      }
    },
    async filterNutrition(val){
      // 兼容原有调用，仅按指标分类筛选
      this.filterType = val
      this.filterNutritionData(val, false)
    },
    // 统一过滤方法：支持指标分类 + 产品对比差异项
    filterNutritionData(nutType, showDiffOnly) {
      this.filterType = nutType
      let list = JSON.parse(JSON.stringify(this.cacheData));
      if (!list || !list.length) {
        this.list.records = [];
        return;
      }

      // 第一步：按指标分类筛选
      if (nutType == 1) {
        list = list.filter(i => i.nutritionValue > 0 || i.nutritionValue < 0);
      } else if (nutType == 2) {
        list = list.filter(i => i.minValue != null || i.maxValue != null || i.minLimitValue != null || i.maxLimitValue != null);
      }

      // 第二步：按产品对比差异项筛选（基于页面显示值比较，精度与 numberFixed 过滤器一致）
      if (showDiffOnly) {
        list = list.filter(i => {
          const len = (i.unit === 'MJ' || i.unit === 'Kcal') ? 0 : 2;
          const nutVal = (i.nutritionValue != null && i.nutritionValue !== '') ? Number(i.nutritionValue).toFixed(len) : '';
          const prodVal = (i.productContent != null && i.productContent !== '') ? Number(i.productContent).toFixed(len) : '';
          return nutVal !== prodVal;
        });
      }

      this.list.records = list;
    },
    async update(data){
      const res = await this.fetchPost({
        data,
        showMessage:false,
        actions:this.formulataskformulanutritionUpdate
      })
      if(this.filterType) this.filterNutrition(this.filterType)
      return res
    },
    len(record){
      return record.unit ==='MJ' || record.unit === 'Kcal' ? 0 : 2
    },
   async getList(arg={}){
      let res = await this.fetchGet({
        actions:this.selectTaskFormulaNutritionByTaskFormulaId,
        name:'list',
        loading:"nutritonListLoading",
        data:{
          taskFormulaId:this.formula.id,
          size:1000,
          ...arg
        }
      })
      let {success,data} = res || {}
      if(success){
        this.cacheData = JSON.parse(JSON.stringify(data.records)) || []
      }
      this.getFilterList()
      return res
    }
  }
}
</script>
